/******************************************
*  Author : Riccardo Di Dato
*  Created On : Thu Jul 28 2022
*  File : ReplaySubject.ts
*******************************************/
import { Observer } from "./Observer.js";
import { Subject } from "./Subject.js";
import { Subscription } from "./Subscription.js";
/**
 * Questa classe è un ibrido tra un BehaviorSubject ed un ReplaySubject di RxJS. Si tratta di un ReplaySubject con un valore di default
 *
 */
export class ReplaySubject extends Subject {
    /**
     * @internal
     */
    memory;
    constructor(size, initial) {
        super();
        this.memory = new ReplayMemory(size);
        this.memory.push(initial);
    }
    /**
     * Callbacks da iscrivere al publisher
     *
     * @param next comportamento in caso di aggiornamento valore corrente
     * @param error comportamento in caso di errore
     * @param complete comportamento in caso di completamento
     */
    subscribe(onNext, onErr = () => { }, onComplete = () => { }) {
        const observer = new Observer(onNext, onErr, onComplete);
        this.observers.push(observer);
        this.memory.forEach((value) => {
            observer.next(value);
        });
        return new Subscription(() => {
            observer.unsubscribe();
            this.observers = this.observers.filter(e => e !== observer);
        });
    }
    next(v) {
        this.memory.push(v);
        super.next(v);
    }
    getCurrentValue() {
        return this.memory.tail();
    }
}
/**
 * @internal
 */
export class ReplayMemory {
    size;
    fifo = [];
    constructor(size) {
        this.size = size;
    }
    push(el) {
        this.fifo.push(el);
        this.fifo = this.fifo.slice(-this.size);
    }
    forEach(act) {
        this.fifo.forEach(act);
    }
    head() {
        return this.fifo[0];
    }
    tail() {
        return this.fifo[this.fifo.length - 1];
    }
}
